import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '../../../contexts/translationContext';
import { theme } from '../../../utils/theme';
import SvgIcon from '../../atoms/SvgIcon';
import Typography from '../../atoms/Typography';

const StyledError = styled(Typography)`
  position: absolute;
  padding-left: 8px;
  padding-top: 4px;
`;

const StyleSvg = styled.div`
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translate(8px, -50%);
`;

const StyledInputWrapper = styled.div`
  position: relative;
`;

interface IinputProps {
  error: string;
}

const StyledInput = styled.input<IinputProps>`
  height: 40px;
  width: 100%;
  outline:none;
  border-radius: 12px;
  border: 1px solid ${({ error }) =>
    error ? `${theme.colors.red[80]}` : '#9E9E9E'};
  padding-left: 8px;
  &:focus {
    outline: none;
    border 1px solid #616161
  }
  outline-width: 0;
`;

const FormikInput = ({
  translateKey,
  field,
  form: { touched, errors },
  placeholder,
  ...props
}) => {
  const { translate } = useTranslation();

  return (
    <div>
      <Typography
        variant="input-label"
        htmlFor={field.name}
        translateKey={translateKey}
      />
      <StyledInputWrapper>
        {touched[field.name] && errors[field.name] && (
          <StyleSvg>
            <SvgIcon
              icon="cross"
              iconSize="small"
              color={theme.colors.red[80]}
            />
          </StyleSvg>
        )}
        <StyledInput
          error={touched[field.name] && errors[field.name]}
          placeholder={translate(placeholder, null)}
          type="text"
          {...field}
          {...props}
        />
        {touched[field.name] && errors[field.name] && (
          <StyledError color={theme.colors.red[80]} variant="input-error">
            {errors[field.name]}
          </StyledError>
        )}
      </StyledInputWrapper>
    </div>
  );
};

export default FormikInput;
